import { EnvironmentName } from "../constants";
import { ClientConfiguration } from "../models";

let clientConfiguration: ClientConfiguration;

export const setClientConfiguration = (configuration: ClientConfiguration) => {
  clientConfiguration = configuration;
};

export const getClientConfiguration = () => {
  if (!clientConfiguration) {
    // Get Client Configuration off the window, where they were set via init.js
    clientConfiguration = (window as any).CLIENT_CONFIGURATION as ClientConfiguration;
    // If we found the configuration on the window...
    if (clientConfiguration) {
      // Ensure Environment Name is lower-cased on client-side (i.e. Environment Names are often capitalized on server)
      clientConfiguration.environmentName = clientConfiguration.environmentName.toLowerCase() as EnvironmentName;
      console.info(
        `App Name: ${clientConfiguration.name}, Version: ${clientConfiguration.version}, Environment: ${clientConfiguration.environmentName}`,
      );
    }
    // Otherwise, we couldn't find it...
    else {
      console.error("Could not find Client Configuration.");
    }
  }

  return clientConfiguration;
};

export const getExtendedClientConfiguration = <T extends {}>() => {
  const clientConfiguration = getClientConfiguration();

  if (clientConfiguration.extended) {
    return clientConfiguration.extended as T;
  }

  console.error("Could not find Extended Client Configuration.");

  return undefined;
};
